import { isUsingFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';
import { getCurrentMarketSpecs } from '@shared/config/market/market.helpers';

const TRIP_PLANNER_PATH = '/travel/plan';

export function isWhiteLabel() {
    return window.location.host.includes('whitelabel');
}

export function isStenaLine() {
    return window.location.host.includes('stenaline');
}

export function isLocalHost() {
    return window.location.host.includes('localhost');
}

export function isPreCheckoutPage() {
    return isPage('/travel/pre-checkout');
}

export function isCheckoutPage() {
    return isPage('/travel/checkout');
}

export function isPostCheckoutPage() {
    return isPage('/travel/post-checkout');
}

export function isBookingsPage() {
    return isPage('/travel/bookings');
}

export function isBookingPage() {
    return isPage('/travel/booking');
}

export function isPaymentPage() {
    return isPage('/travel/payment');
}

function isPage(path: string) {
    const { pathname } = window.location;
    return pathname === path || pathname === `${path}/`;
}

export function getTripPlannerUrl(): string {
    if (isLocalHost() || isUsingFakeData()) {
        return `${getCurrentMarketSpecs().homePage}${TRIP_PLANNER_PATH}`;
    }
    return `${window.location.origin}${TRIP_PLANNER_PATH}`;
}

export enum RedirectionType {
    Assign,
    Replace,
}

export function redirectTo(url: string, type: RedirectionType) {
    switch (type) {
        // does not add url to history.
        case RedirectionType.Replace:
            window.location.replace(url);
            break;
        // adds url to history
        default:
            window.location.assign(url);
            break;
    }
}
